/**
 * Shared performance types — safe to import from workers (no Sentry).
 */

/**
 * @typedef {Object} Timing
 * @property {string} name
 * @property {string} op
 * @property {number} duration - milliseconds
 * @property {Record<string, unknown>} [data]
 */

/**
 * Slow operation thresholds in milliseconds.
 * Operations exceeding these are captured as Sentry issues at 100% rate.
 */
export const SLOW_THRESHOLD = {
  drag: 100,
  transform: 100,
  canvas_capture: 2000,
  worker_encode: 1000,
}
